import { BackdropProps, Box, Fade, SxProps, Theme } from '@mui/material';
import Modal from '@mui/material/Modal';
import { FC, ReactNode } from 'react';

const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 4,
};

interface BasicModalType {
    open: boolean;
    children: ReactNode;
    sx?: SxProps<Theme>;
    modalClass?: string;
    slotProps?: {
        backdrop?: Partial<BackdropProps>;
    };
    onClose?: () => void;
}

const BasicModal: FC<BasicModalType> = ({
    open,
    onClose,
    children,
    sx,
    slotProps,
    modalClass = '',
}) => {
    return (
        <div>
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                slotProps={slotProps}
                className={modalClass}
            >
                <Fade timeout={300} in={open}>
                    <Box sx={sx ?? style}>{children}</Box>
                </Fade>
            </Modal>
        </div>
    );
};

export default BasicModal;
